<!-- <div class="start-container">
  <div>
    <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: -5%;"></i></span>
    <span class="image"></span>
  </div>
  <label class="lblHeader">{{'Start Here'|translate}}</label>
  <label class="lbl-text">{{'network test text1'|translate}}
    <a>{{'click here'|translate}}.</a>
  </label>
  <label class="lbl-text2">{{'Click the start button to continue'|translate}}</label>
  <div>
    <span>
      <button class="btn-start" (click)="startNetworkTest()">{{'Start'|translate}}</button>
      <button *ngIf="isShowOverRide" class="btn-override" routerLink="/symptoms">{{'Override'|translate}}</button>
      *ngIf="isShowOverRide"
    </span>
  </div>
</div>
<div class="network-container">
  <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span>
  <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
  <div *ngIf="!progressbar && !isNetwork">
    <label class="network-status">{{'FDRS Network test Not Running'|translate}}</label>
  </div>
  <div *ngIf="progressbar && !isNetwork" class="progress">
    <div class="progress-bar progress-bar-striped s row_padding"></div>
  </div>
  <div *ngIf="progressbar && !isNetwork" style="margin-left: 3%;">
    {{'Performing Network Test'|translate}}..
  </div>
  <div *ngIf="isNetwork" style="margin-left: 3%;">
    {{'Network test is completed'|translate}}.
  </div>
</div> -->

<!-- <ng-container *ngIf="isShowOverrideBlock">
  <div class="start-container">
    <div>
      <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: -5%;"></i></span>
      <span class="image"></span>
    </div>
    <label class="lblHeader">{{'Start Here'|translate}}</label>
    <label class="lbl-text">{{'network test text1'|translate}}
      <a>{{'click here'|translate}}.</a>
    </label>
    <label class="lbl-text2">{{'Click the start button to continue'|translate}}</label>
    <div>
      <span>
        <button class="btn-start" (click)="startNetworkTest()">{{'Start'|translate}}</button>
        <button class="btn-override" (click)="overrideBtnClicked()">{{'Override'|translate}}</button>
      </span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isShowTestProgressBlock">
  <div class="network-container">
    <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span>
    <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
    <div *ngIf="!progressbar && !isNetwork">
      <label class="network-status">{{'FDRS Network test Not Running'|translate}}</label>
    </div>
    <div *ngIf="progressbar && !isNetwork" class="progress">
      <div class="progress-bar progress-bar-striped s row_padding"></div>
    </div>
    <div *ngIf="progressbar && !isNetwork" style="margin-left: 3%;">
      {{'Performing Network Test'|translate}}..
    </div>
    <div *ngIf="isNetwork" style="margin-left: 3%;">
      {{'Network test is completed'|translate}}.
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isShowReRunBlock">
  <ng-container *ngIf="isFDRSConnected">
    <div class="network-container">
      <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span>
      <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
      <!-- <div *ngIf="!progressbar && !isNetwork"> -->
<!-- <label class="network-status">The System has current Information for this vehicle,therefore,
        you are not required to run the network test application.<a href="javascript:void(0);" class="link"
          (click)="reRunNetworkTest()">Re-run the network test</a></label> -->
<!-- </div> -->
<!-- </div>
  </ng-container>
</ng-container>  -->

<!-- Start -->

<ng-container *ngIf="isFDRSConnected">
  <!-- <ng-container *ngIf="!isDisableNwHeader"> -->
      <label class="header" id="nwHeader">{{'Network Test'|translate}} </label>
  <!-- </ng-container> -->
</ng-container>

<!-- <ng-container *ngIf="isNetworkTestNeeded"> -->
  <ng-container *ngIf="isFDRSConnected">
      <ng-container *ngIf="isShowOverrideBlock">
          <div class="start-container">
              <div>
                  <span><i class="fa fa-info-circle"
                          style="color: gray !important;font-size:14px; margin-left: -5%;"></i></span>
                  <span class="image"></span>
              </div>
              <label class="lblHeader">{{'Start Here'|translate}}</label>
              <label class="lbl-text">{{'network test text1'|translate}}
                  <a>{{'click here'|translate}}.</a>
              </label>
              <label class="lbl-text2">{{'Click the start button to continue'|translate}}</label>
              <div>
                  <span>
                      <button class="btn-start" (click)="startNetworkTest()">{{'Start'|translate}}</button>
                      <button class="btn-override" (click)="overrideBtnClicked()">{{'Override'|translate}}</button>
                  </span>
              </div>
          </div>
      </ng-container>
  </ng-container>
<!-- </ng-container> -->

<!-- <ng-container *ngIf="isNetworkTestNeeded"> -->
  <ng-container *ngIf="isFDRSConnected">
      <ng-container *ngIf="isShowTestProgressBlock">
          <div class="network-container">
              <span><i class="fa fa-info-circle"
                      style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span>
              <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
              <div *ngIf="!progressbar && !isNetwork && !isNetworkTestError">
                  <label class="network-status">{{'FDRS Network test Not Running'|translate}}</label>
              </div>
              <div *ngIf="progressbar && !isNetwork && !isNetworkFailure" class="progress">
                  <div class="progress-bar progress-bar-striped s row_padding"></div>
              </div>
              <div *ngIf="progressbar && !isNetwork && !isNetworkFailure" style="margin-left: 3%;">
                  {{'Performing Network Test'|translate}}..
              </div>
              <div *ngIf="isNetwork" style="margin-left: 3%;">
                  <!-- {{'Network test is completed'|translate}}. -->
                  {{'Network test is completed successfully'|translate}}.
              </div>
              <div *ngIf="isNetworkFailure" style="margin-left: 3%;">
                  {{'Network test Fails to complete'|translate}}.
              </div>
          </div>
      </ng-container>
  </ng-container>
<!-- </ng-container> -->

<ng-container *ngIf="isNetworkTestError">
  <ng-container *ngIf="isFDRSConnected">
      <div class="network-container">
          <span><i class="fa fa-info-circle"
                  style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span>
          <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
          <div>
              <span>
                  <label class="network-status">{{'FDRS Network Test Failed click to re run'|translate}}</label>
                  <button class="btn-start" (click)="retryNetworkTest()">{{'RUN'|translate}}</button>
              </span>
          </div>

      </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="isNWTestFailedMultiple">
  <ng-container *ngIf="isFDRSConnected">
      <div class="network-container">
          <span><i class="fa fa-info-circle"
                  style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span>
          <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
          <div>
              <span>
                  <label class="network-status">{{'FDRS Network Test Failed multiple times continue with previous data retry or close'|translate}}?</label>
              </span>
              <span>
                  <button class="btn-start-multiple" (click)="retryNetworkTest()">{{'RUN'|translate}}</button>
                  <button class="btn-override-multiple" (click)="overrideBtnClicked()">{{'Override'|translate}}</button>
              </span>
          </div>
      </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="isNWTestFailedAdmin">
  <ng-container *ngIf="isFDRSConnected">
      <div class="network-container">
          <span><i class="fa fa-info-circle"
                  style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span>
          <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
          <div>
              <span>
                  <label class="network-status">{{'FDRS Network Test Failed continue with previous sdata retry or close'|translate}}?</label>
                  <button class="btn-start-failure" (click)="retryNetworkTest()">{{'RUN'|translate}}</button>
                  <button class="btn-override-failure" (click)="overrideBtnClicked()">{{'Override'|translate}}</button>
              </span>
          </div>
      </div>
  </ng-container>
</ng-container>
<ng-template #NWTTestErrorInfo let-modal>
  <div class="container NWTContainer">
      <div class="row popup-header">
          <div class="pull-left">{{'Information'|translate}}</div>
          <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                  (click)="modal.dismiss('NWTTestErrorInfo')"></i></div>
      </div>
      <div>
        <label class='msg-body'>{{'An error occurred when running the application|translate'}}. {{'Cause'|translate}}: {{networkTestErrorMsg}}<br>
          {{'Close the message box and try again'|translate}}.{{'Network Test Message1'|translate}}.
          </label>
      </div>
      <hr class="hr-line">
      <div class="popup-footer">
        <button type="button" class="close-btn-popup pull-right" name="cancel"
            (click)="modal.dismiss('NWTTestErrorInfo')">{{'Continue'|translate | uppercase}}</button>
    </div>
  </div>
</ng-template>


<!-- <ng-template #FDRSClosedAlert let-modal>
  <div class="container version">
    <div class="row popup-header">
      <div class="pull-left">Information</div>
      <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
          (click)="modal.dismiss('FDRSClosedAlert')"></i></div>
    </div>
    <div class="version-subtext">
      An error occured while running the application. Close the message box and try again.
    </div>

    <hr class="hr-line">
    <div class="popup-footer">
      <button type="button" class="delete-btn pull-right" name="close" (click)="continueSymptoms()">Continue</button>
    </div>
  </div>
</ng-template> -->
<routeroutlet></routeroutlet>